export default "__VITE_ASSET__3bfda98a__"